import { createContext, useState } from 'react';

export const RefreshContext = createContext();

export const RefreshProvider = ({ children }) => {
  const [refresh, setRefresh] = useState(0);

  const triggerRefresh = () => {
    setRefresh((prev) => prev + 1);
  };

  const refreshData = () => {
    triggerRefresh();
    return Promise.resolve();
  };

  return (
    <RefreshContext.Provider value={{ refresh, triggerRefresh, refreshData }}>
      {children}
    </RefreshContext.Provider>
  );
};